<kendo-expansionpanel
    class="qpoint-expansion-panel"
    [title]="title"
    [expanded]="expanded"
    [subtitle]="subtitle"
    [disabled]="disabled"
    (expandedChange)="onExpandedChange($event)"
    [svgCollapseIcon]="collapseIcon"
    [svgExpandIcon]="expandIcon"
>
    <ng-content></ng-content>
</kendo-expansionpanel>